/* ============================================================================
FILE: po-katupirsia5-oendomare-texts-fr-en-es-20260313.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5OendomareTextsFR_EN_ES_20260313
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_OENDOMARE_TEXTS_20260313__) return;
  window.__PO_K5_OENDOMARE_TEXTS_20260313__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="oendomare"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau de Syntonie",
      "Sceau d’Équiphase",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau d’Œndomare",
      "Syntōnēa",
      "Ēkuphasa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/Guide-number/gi, "Nombre-guide"],
    [/Guide number/gi, "Nombre-guide"],
    [/N[uú]mero-gu[ií]a/gi, "Nombre-guide"],
    [/Frequency 421/gi, "Fréquence d’alignement 421"],
    [/Frecuencia 421/gi, "Fréquence d’alignement 421"],
    [/Seal of Oendomare/gi, "Sceau d’Œndomare"],
    [/Sello de Œndomare/gi, "Sceau d’Œndomare"],
    [/Source-beat/gi, "battement-source"],
    [/Latido-fuente/gi, "battement-source"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bN[uú]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 492\b/gi, "Fréquence 492"],
    [/\bFrecuencia 492\b/gi, "Fréquence 492"],
    [/\bSeal of Syntony\b/gi, "Sceau de Syntonie"],
    [/\bSello de Sinton[ií]a\b/gi, "Sceau de Syntonie"],
    [/\bPlural subject\b/gi, "Sujet pluriel"],
    [/\bSujeto plural\b/gi, "Sujet pluriel"],
    [/\bMultiple instantaneity\b/gi, "Instantané multiple"],
    [/\bInstant[aá]neo m[uú]ltiple\b/gi, "Instantané multiple"],
    [/\bSuperposition of perspectives\b/gi, "Superposition de perspectives"],
    [/\bSuperposici[oó]n de perspectivas\b/gi, "Superposition de perspectives"],
    [/\bExpanded temporality\b/gi, "Temporalité élargie"],
    [/\bTemporalidad extensiva\b/gi, "Temporalité élargie"],
    [/\bBroken-out temporality\b/gi, "Temporalité éclatée"],
    [/\bTemporalidad estallada\b/gi, "Temporalité éclatée"],
    [/\bPosœnnoïal meditations\b/gi, "Méditations Posœnnoïales"],
    [/\bMeditaciones posœnnoïales\b/gi, "Méditations Posœnnoïales"],
    [/\bPosœnnoïal agreements\b/gi, "Accords Posœnnoïaux"],
    [/\bAcuerdos posœnnoïaux\b/gi, "Accords Posœnnoïaux"],
    [/\bPosœnnoïal Organon\b/gi, "Organon posœnnoïal"],
    [/\bSyntony\b/gi, "syntonie"],
    [/\bSinton[ií]a\b/gi, "syntonie"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  var CONTENT = {
  "fr": {
    "title": "Œndomarê",
    "kicker": "Entité isqunienne de Threnisqun — reconnexion aux pulsations originelles et stabilisation des seuils vibratoires instables.",
    "title_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Oendomare_copie.png?v=1772924648",
      "alt": "Idéogramme de Œndomarê"
    },
    "h_def": "Définition canonique",
    "chip_1": "Sceau associé : Sceau d’Œndomare",
    "chip_1_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_2.png?v=1772906456",
      "alt": "Sceau d’Œndomare"
    },
    "chip_2": "Fréquence d’alignement 421",
    "chip_2_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_421.png?v=1773449520",
      "alt": "Nombre-guide 421"
    },
    "chip_3": "Entité de Threnisqun",
    "chip_3_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862",
      "alt": "Entité de Threnisqun"
    },
    "def_short": "<strong>Œndomarê</strong> capte, dissout et redistribue les flux infraconscients non orientés afin de restaurer la respiration psychique, la continuité perceptive et l’axe intérieur par retour au battement-source.",
    "def_long": "<p><strong>Œndomarê</strong> est l’entité posœnnoïale de dispersion subtile et de reconnexion aux pulsations originelles, émanée du <strong>Sceau d’Œndomare</strong>. Elle intervient lorsque l’expérience n’arrive plus à tenir : brouillard intérieur, fatigue diffuse, idées parasites, résidus oniriques, dissociation légère ou seuil vibratoire fragilisé.</p><p>Dans la logique <strong>Isqun → Threnisqun</strong>, le <strong>Sceau d’Œndomare</strong> régule à l’échelle profonde les flux psychiques diffus, tandis que <strong>Œndomarê</strong> en devient la densité opérative, située, respirable et praticable dans les moments de passage.</p>",
    "h_grid": "Structure vibratoire",
    "grid_type_label": "Type",
    "grid_type_value": "Entité posœnnoïale de dispersion subtile et de stabilisation des seuils vibratoires",
    "grid_freq_label": "Nombre-guide",
    "grid_freq_value": "421",
    "grid_scope_label": "Axes et déploiement",
    "grid_scope_value": "<ul><li>Champ : brouillard intérieur, idées parasites, dissociation, résidus oniriques</li><li>Mode : silence profond, respiration longue, mer noire, cercle de seuil</li><li>Fonction : reconnexion aux pulsations originelles et maintien de l’axe dans la mutation</li></ul>",
    "h_intro": "Quand le seuil fatigue et que l’axe se brouille",
    "p_intro": "<p><strong>Œndomarê</strong> intervient lorsque la transition devient trop dense pour rester traversable : fin de cycle, exil, initiation, passage identitaire, seuil d’existence, ou simple saturation de fond qui décentre la présence.</p><p>Sa logique est liquide et structurante à la fois. Elle dissout les résidus sans dissoudre l’être ; elle laisse revenir le battement-source jusqu’à ce que la traversée redevienne habitable.</p>",
    "h_actions": "Fonctionnement rituelo-symbolique",
    "actions": "<ol><li>Reconnaître la fatigue du seuil : flottement, brouillard, perte de direction ou dispersion du champ intérieur.</li><li>Installer un silence profond et laisser la respiration s’allonger jusqu’à retrouver une cadence plus vaste.</li><li>Nommer <strong>Œndomarê</strong> comme point d’ancrage mouvant plutôt que comme verrou.</li><li>Laisser les flux infraconscients se dissoudre et se redistribuer sans forçage interprétatif.</li><li>Revenir au battement-source, là où la mutation retrouve une cohérence praticable.</li></ol>",
    "h_phrase": "Phrase opérative",
    "phrase": "<p>« Œndomarê : je descends dans la mer silencieuse, je laisse les résidus se dissoudre, et le battement-source revient comme une présence. »</p>",
    "h_table": "Tableau d’usage",
    "table_head_1": "Situation",
    "table_head_2": "Signe",
    "table_head_3": "Action de Œndomarê",
    "table_rows": "<tr><td>Brouillard intérieur</td><td>Fatigue diffuse sans cause nette</td><td>Dissout les parasites infraconscients et réinstalle un axe respirant</td></tr><tr><td>Passage de cycle</td><td>Instabilité, flottement, identité fragile</td><td>Stabilise le seuil sans figer la mutation</td></tr><tr><td>Résidus oniriques ou mentaux</td><td>Images insistantes, surcharge de fond</td><td>Redistribue les flux en les rendant à une mer intérieure silencieuse</td></tr><tr><td>Saut vibratoire / rite liminaire</td><td>Perte de cohésion pendant la bascule</td><td>Maintient la continuité perceptive et la mémoire du passage</td></tr>",
    "h_entite": "Sceau d’Œndomare",
    "entite_kicker": "Source isqunienne de Œndomarê",
    "entite_body": "<p>Le <strong>Sceau d’Œndomare</strong> porte la fonction de reconnexion entre pulsations originelles et cosmos étendu. <strong>Œndomarê</strong> en est la densité opérative activable dans <strong>Threnisqun</strong>.</p><p>Là où le Sceau régule les flux psychiques diffus, l’entité rend cette régulation présente, située et praticable dans les seuils de passage, les saturations de fond et les pratiques liminaires.</p>",
    "h_ritual": "Rituel d’activation",
    "ritual_name_label": "Nom",
    "ritual_name_value": "Ancrage mouvant du seuil",
    "ritual_steps": "<ol><li>Tracer un cercle au sol avec des éléments mobiles : pierre, ficelle, sable.</li><li>Se tenir à l’extérieur du cercle, puis respirer profondément dans le silence.</li><li>Entrer dans le cercle en disant lentement : Œn–do–ma–rê.</li><li>Rester immobile un instant au centre, comme une barque stable sur une mer noire.</li><li>Ressortir lentement en laissant un objet à l’intérieur, symbole du passage redistribué.</li></ol>",
    "h_moments": "Moments privilégiés",
    "moments": "<ul><li>Brouillard intérieur ou fatigue mentale diffuse</li><li>Rêves répétitifs, images insistantes, surcharge infraconsciente</li><li>Après une journée saturée de stimuli, de paroles ou de foule</li><li>Avant ou après un saut vibratoire, un passage initiatique, un seuil d’existence</li></ul>",
    "h_syntony": "Syntonies Katûvýsiennes",
    "syntony": "<ul><li><strong>Katûvýsissence</strong> — stabilisation de la mémoire profonde et de la pulsation-source</li><li><strong>Extratinrieur</strong> — régulation des seuils lorsque la porosité au réel crée surcharge</li><li><strong>Tiqqunbahu</strong> — fragmentation recomposable des résidus dissous</li><li><strong>Ušôprogalenmestûd</strong> — passage et redistribution des flux d’origine non localisée</li><li><strong>Lulæṣírasen</strong> / <strong>Taxiêlîs</strong> — ralentissement des vortex instables et stabilisation des interconnexions vibratoires lors des mutations</li><li><strong>Expérience fragmentée</strong> — maintien de la cohésion pendant l’éclatement d’un cycle</li><li><strong>Posœnnomia</strong> — pratiques collectives de clarification et d’assainissement du champ commun</li></ul>",
    "cta_translate": "Proposer une traduction du concept"
  },
  "en": {
    "title": "Œndomarê",
    "kicker": "Entité isqunienne de Threnisqun — reconnection to original pulsations and stabilization of unstable vibratory thresholds.",
    "title_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Oendomare_copie.png?v=1772924648",
      "alt": "Idéogramme de Œndomarê"
    },
    "h_def": "Canonical definition",
    "chip_1": "Associated seal: Sceau d’Œndomare",
    "chip_1_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_2.png?v=1772906456",
      "alt": "Sceau d’Œndomare"
    },
    "chip_2": "Fréquence d’alignement 421",
    "chip_2_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_421.png?v=1773449520",
      "alt": "Nombre-guide 421"
    },
    "chip_3": "Entité de Threnisqun",
    "chip_3_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862",
      "alt": "Entité de Threnisqun"
    },
    "def_short": "<strong>Œndomarê</strong> captures, dissolves, and redistributes unoriented infraconscious flows so as to restore psychic respiration, perceptive continuity, and the inner axis through a return to the battement-source.",
    "def_long": "<p><strong>Œndomarê</strong> is the posœnnoïal entity of subtle dispersion and reconnection to original pulsations, emanated from the <strong>Sceau d’Œndomare</strong>. It intervenes when experience can no longer hold together: inner fog, diffuse fatigue, parasitic ideas, oneiric residues, slight dissociation, or fragile vibratory thresholds.</p><p>Within the <strong>Isqun → Threnisqun</strong> logic, the <strong>Sceau d’Œndomare</strong> regulates diffuse psychic flows at a deep scale, while <strong>Œndomarê</strong> becomes their activable operative density in threshold passages and background saturations.</p>",
    "h_grid": "Vibratory structure",
    "grid_type_label": "Type",
    "grid_type_value": "Posœnnoïal entity of subtle dispersion and stabilization of vibratory thresholds",
    "grid_freq_label": "Nombre-guide",
    "grid_freq_value": "421",
    "grid_scope_label": "Axes and deployment",
    "grid_scope_value": "<ul><li>Field: inner fog, parasitic ideas, dissociation, oneiric residues</li><li>Mode: deep silence, long breathing, black sea, threshold-circle</li><li>Function: reconnection to original pulsations and maintenance of axis within mutation</li></ul>",
    "h_intro": "When the threshold tires and the axis blurs",
    "p_intro": "<p><strong>Œndomarê</strong> intervenes when transition becomes too dense to remain traversable: end of cycle, exile, initiation, identity passage, existential threshold, or simple background saturation that decenters presence.</p><p>Its logic is both liquid and structuring. It dissolves residues without dissolving the being; it lets the battement-source return until the crossing becomes inhabitable again.</p>",
    "h_actions": "Ritual-symbolic functioning",
    "actions": "<ol><li>Recognize threshold fatigue: floating, inner fog, loss of direction, or dispersion of the inner field.</li><li>Install a deep silence and let breathing lengthen until a wider cadence returns.</li><li>Name <strong>Œndomarê</strong> as a moving anchorage rather than a lock.</li><li>Let infraconscious flows dissolve and redistribute without interpretive forcing.</li><li>Return to the battement-source, where mutation regains a practicable coherence.</li></ol>",
    "h_phrase": "Operative phrase",
    "phrase": "<p>“Œndomarê: I descend into the silent sea, I let the residues dissolve, and the battement-source returns as a presence.”</p>",
    "h_table": "Usage table",
    "table_head_1": "Situation",
    "table_head_2": "Sign",
    "table_head_3": "Action of Œndomarê",
    "table_rows": "<tr><td>Inner fog</td><td>Diffuse fatigue with no clear cause</td><td>Dissolves infraconscious parasites and restores a breathing axis</td></tr><tr><td>Cycle passage</td><td>Instability, floating, fragile identity</td><td>Stabilizes the threshold without freezing mutation</td></tr><tr><td>Oneiric or mental residues</td><td>Insistent images, background overload</td><td>Redistributes flows by returning them to a silent inner sea</td></tr><tr><td>Vibratory leap / liminal rite</td><td>Loss of cohesion during transition</td><td>Maintains perceptive continuity and the memory of passage</td></tr>",
    "h_entite": "Sceau d’Œndomare",
    "entite_kicker": "Isqunian source of Œndomarê",
    "entite_body": "<p>The <strong>Sceau d’Œndomare</strong> carries the function of reconnection between original pulsations and the extended cosmos. <strong>Œndomarê</strong> is its activable operative density within <strong>Threnisqun</strong>.</p><p>Where the Seal regulates diffuse psychic flows, the entity renders this regulation present, situated, and practicable within threshold passages, background saturation, and liminal practices.</p>",
    "h_ritual": "Activation ritual",
    "ritual_name_label": "Name",
    "ritual_name_value": "Ancrage mouvant du seuil",
    "ritual_steps": "<ol><li>Trace a circle on the ground using mobile elements: stone, string, sand.</li><li>Stand outside the circle and breathe deeply in silence.</li><li>Enter the circle while slowly saying: Œn–do–ma–rê.</li><li>Remain still for a moment at the center, like a stable boat on a black sea.</li><li>Step out slowly, leaving an object inside as the symbol of redistributed passage.</li></ol>",
    "h_moments": "Privileged moments",
    "moments": "<ul><li>Inner fog or diffuse mental fatigue</li><li>Repetitive dreams, insistent images, infraconscious overload</li><li>After a day saturated with stimuli, speech, or crowd</li><li>Before or after a vibratory leap, an initiatory passage, or an existential threshold</li></ul>",
    "h_syntony": "Syntonies Katûvýsiennes",
    "syntony": "<ul><li><strong>Katûvýsissence</strong> — stabilization of deep memory and source-pulsation</li><li><strong>Extratinrieur</strong> — regulation of thresholds when porosity to the real creates overload</li><li><strong>Tiqqunbahu</strong> — recomposable fragmentation of dissolved residues</li><li><strong>Ušôprogalenmestûd</strong> — passage and redistribution of flows of non-localized origin</li><li><strong>Lulæṣírasen</strong> / <strong>Taxiêlîs</strong> — slowing unstable vortexes and stabilizing vibratory interconnections during mutations</li><li><strong>Expérience fragmentée</strong> — maintenance of cohesion during the bursting of a cycle</li><li><strong>Posœnnomia</strong> — collective practices of clarification and cleansing of the shared field</li></ul>",
    "cta_translate": "Proposer une traduction du concept"
  },
  "es": {
    "title": "Œndomarê",
    "kicker": "Entité isqunienne de Threnisqun — reconexión con las pulsaciones originelles y estabilización de los umbrales vibratorios inestables.",
    "title_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Oendomare_copie.png?v=1772924648",
      "alt": "Idéogramme de Œndomarê"
    },
    "h_def": "Definición canónica",
    "chip_1": "Sello asociado: Sceau d’Œndomare",
    "chip_1_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_2.png?v=1772906456",
      "alt": "Sceau d’Œndomare"
    },
    "chip_2": "Fréquence d’alignement 421",
    "chip_2_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_421.png?v=1773449520",
      "alt": "Nombre-guide 421"
    },
    "chip_3": "Entité de Threnisqun",
    "chip_3_img": {
      "src": "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862",
      "alt": "Entité de Threnisqun"
    },
    "def_short": "<strong>Œndomarê</strong> capta, disuelve y redistribuye los flujos infraconscientes no orientados para restaurar la respiración psíquica, la continuidad perceptiva y el eje interior mediante el retorno al battement-source.",
    "def_long": "<p><strong>Œndomarê</strong> es la entidad posœnnoïale de dispersión sutil y reconexión con las pulsaciones originarias, emanada del <strong>Sceau d’Œndomare</strong>. Interviene cuando la experiencia ya no logra sostenerse: niebla interior, fatiga difusa, ideas parásitas, residuos oníricos, ligera disociación o umbral vibratorio fragilizado.</p><p>En la lógica <strong>Isqun → Threnisqun</strong>, el <strong>Sceau d’Œndomare</strong> regula en profundidad los flujos psíquicos difusos, mientras <strong>Œndomarê</strong> se vuelve su densidad operativa activable en los pasajes de umbral y las saturaciones de fondo.</p>",
    "h_grid": "Estructura vibratoria",
    "grid_type_label": "Tipo",
    "grid_type_value": "Entité posœnnoïale de dispersión sutil y estabilización de los umbrales vibratorios",
    "grid_freq_label": "Nombre-guide",
    "grid_freq_value": "421",
    "grid_scope_label": "Ejes y despliegue",
    "grid_scope_value": "<ul><li>Campo: niebla interior, ideas parásitas, disociación, residuos oníricos</li><li>Modo: silencio profundo, respiración larga, mar negra, círculo de umbral</li><li>Función: reconexión con las pulsaciones originarias y mantenimiento del eje dentro de la mutación</li></ul>",
    "h_intro": "Cuando el umbral se fatiga y el eje se nubla",
    "p_intro": "<p><strong>Œndomarê</strong> interviene cuando la transición se vuelve demasiado densa para seguir siendo atravesable: fin de ciclo, exilio, iniciación, pasaje identitario, umbral de existencia o simple saturación de fondo que descentra la presencia.</p><p>Su lógica es líquida y estructurante a la vez. Disuelve los residuos sin disolver el ser; deja volver el battement-source hasta que la travesía vuelva a ser habitable.</p>",
    "h_actions": "Funcionamiento ritual-simbólico",
    "actions": "<ol><li>Reconocer la fatiga del umbral: flotación, niebla interior, pérdida de dirección o dispersión del campo interno.</li><li>Instalar un silencio profundo y dejar que la respiración se alargue hasta recuperar una cadencia más amplia.</li><li>Nombrar <strong>Œndomarê</strong> como anclaje móvil y no como cierre.</li><li>Dejar que los flujos infraconscientes se disuelvan y redistribuyan sin forzar interpretación.</li><li>Regresar al battement-source, allí donde la mutación recobra una coherencia practicable.</li></ol>",
    "h_phrase": "Frase operativa",
    "phrase": "<p>« Œndomarê: desciendo al mar silencioso, dejo que los residuos se disuelvan, y el battement-source regresa como una presencia. »</p>",
    "h_table": "Tabla de uso",
    "table_head_1": "Situación",
    "table_head_2": "Signo",
    "table_head_3": "Acción de Œndomarê",
    "table_rows": "<tr><td>Niebla interior</td><td>Fatiga difusa sin causa clara</td><td>Disuelve los parásitos infraconscientes y restituye un eje respirante</td></tr><tr><td>Pasaje de ciclo</td><td>Inestabilidad, flotación, identidad frágil</td><td>Estabiliza el umbral sin inmovilizar la mutación</td></tr><tr><td>Residuos oníricos o mentales</td><td>Imágenes insistentes, sobrecarga de fondo</td><td>Redistribuye los flujos devolviéndolos a un mar interior silencioso</td></tr><tr><td>Salto vibratorio / rito liminar</td><td>Pérdida de cohesión durante el paso</td><td>Mantiene la continuidad perceptiva y la memoria del pasaje</td></tr>",
    "h_entite": "Sceau d’Œndomare",
    "entite_kicker": "Fuente isqunienne de Œndomarê",
    "entite_body": "<p>El <strong>Sceau d’Œndomare</strong> porta la función de reconexión entre pulsaciones originarias y cosmos extendido. <strong>Œndomarê</strong> es su densidad operativa activable dentro de <strong>Threnisqun</strong>.</p><p>Allí donde el Sello regula los flujos psíquicos difusos, la entidad vuelve esta regulación presente, situada y practicable en los pasajes de umbral, las saturaciones de fondo y las prácticas liminares.</p>",
    "h_ritual": "Ritual de activación",
    "ritual_name_label": "Nombre",
    "ritual_name_value": "Ancrage mouvant du seuil",
    "ritual_steps": "<ol><li>Trazar un círculo en el suelo con elementos móviles: piedra, cuerda, arena.</li><li>Permanecer fuera del círculo y respirar profundamente en silencio.</li><li>Entrar en el círculo diciendo lentamente: Œn–do–ma–rê.</li><li>Quedarse inmóvil un instante en el centro, como una barca estable sobre un mar negro.</li><li>Salir lentamente dejando un objeto en el interior como símbolo del pasaje redistribuido.</li></ol>",
    "h_moments": "Momentos privilegiados",
    "moments": "<ul><li>Niebla interior o fatiga mental difusa</li><li>Sueños repetitivos, imágenes insistentes, sobrecarga infraconsciente</li><li>Después de una jornada saturada de estímulos, de palabras o de multitud</li><li>Antes o después de un salto vibratorio, un paso iniciático o un umbral de existencia</li></ul>",
    "h_syntony": "Syntonies Katûvýsiennes",
    "syntony": "<ul><li><strong>Katûvýsissence</strong> — estabilización de la memoria profunda y de la pulsación-fuente</li><li><strong>Extratinrieur</strong> — regulación de los umbrales cuando la porosidad con lo real crea sobrecarga</li><li><strong>Tiqqunbahu</strong> — fragmentación recomponible de los residuos disueltos</li><li><strong>Ušôprogalenmestûd</strong> — paso y redistribución de flujos de origen no localizado</li><li><strong>Lulæṣírasen</strong> / <strong>Taxiêlîs</strong> — ralentización de vórtices inestables y estabilización de las interconexiones vibratorias durante las mutaciones</li><li><strong>Expérience fragmentée</strong> — mantenimiento de la cohesión durante el estallido de un ciclo</li><li><strong>Posœnnomia</strong> — prácticas colectivas de clarificación y saneamiento del campo compartido</li></ul>",
    "cta_translate": "Proposer une traduction du concept"
  }
};

function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try {
        PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle");
      } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5OendomareInit) return;
    root.__poK5OendomareInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5OendomareTextsFR_EN_ES_20260313 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
